import { useCallback } from 'react';
import { decodeJwt } from 'jose';
import { useAuthRepository, IAcessoResponse } from '../../infra/auth';
import { useAppDispatch } from '../../presentation/hooks/store-hooks';
import { setToken } from '../../application/states/auth';

export const useAuthService = () => {
  const { insertAcessoApi, refreshToken, getSessionConfig } = useAuthRepository();
  const dispatch = useAppDispatch();

  const insertAcesso = useCallback(async (idProduto: number = 14): Promise<IAcessoResponse | null> => {
    try {
      const tokenStorage = localStorage.getItem('ACCESS_TOKEN');
      if (!tokenStorage) return null;

      const decoded = decodeJwt(tokenStorage) as { IdUsuario?: number; idUsuario?: number };
      const idUsuario = Number(decoded?.IdUsuario || decoded?.idUsuario);

      const response = await insertAcessoApi({
        IdProduto: idProduto,
        IdUsuario: idUsuario,
      });

      if (response && response.accessToken) {
        localStorage.setItem('ACCESS_TOKEN', response.accessToken);
        dispatch(setToken({ token: response.accessToken }));
      }

      return response;
    } catch (error) {
      console.error('Erro ao executar insertAcesso:', error);
      throw error;
    }
  }, [dispatch, insertAcessoApi]);

  return {
    insertAcesso,
    refreshToken,
    getSessionConfig,
  };
};
